import type { components } from '@sportik/api-coach/schema';

type ClientState = components['schemas']['Client']['state'];

/**
 * Whether coaching is open: the client is active or paused. Once it has ended
 * (stopped or archived) the coach reads none of the athlete's records
 * (PD-008) and changes nothing about their program.
 */
export function isCoached(state: ClientState) {
  return state === 'active' || state === 'paused';
}
